// eslint-disable-next-line import/prefer-default-export
export const STANDARDBAU_SUBSTATI = 'standardbau_substati';

export const STANDARD_GRUPPEN_FLAT = 'standard_gruppen_flat';
export const STANDARD_STANDORTE_FLAT = 'standard_standorte_flat';
